module.exports = __webpack_public_path__ + "static/img/brees-2017-slide-8.fad7a7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2017-slide-8.jpg
// module id = A6Di
// module chunks = 1